module.exports = __webpack_public_path__ + "img/googleIcon.3783daab.svg";